import React from 'react'
import { Box, CircularProgress, Container, Paper, Stack, Typography } from '@mui/material'
import { DataGrid, GridToolbar } from '@mui/x-data-grid'
import moment from 'moment'
import { useGetMapsDashboard } from '../../../hooks/api/map'
import ErrorMessage from '../../errors/ErrorMessage'

const columns = [
  { field: 'companyName', headerName: 'Company Name', minWidth: 200 },
  { field: 'salesId', headerName: 'Sales ID', minWidth: 90 },
  { field: 'htgCompany', headerName: 'HTG Company', minWidth: 100 },
  {
    field: 'contractPeriod',
    headerName: 'Contract Period',
    minWidth: 200,
    valueGetter: (params) =>
      `${moment(params.row.contractStartDate).format('L')} - ${moment(params.row.contractEndDate).format('L')}`,
    sortComparator: (_v1, _v2, param1, param2) =>
      moment(param1.api.getRow(param1.id).contractStartDate).valueOf() -
      moment(param2.api.getRow(param2.id).contractStartDate).valueOf(),
  },
  {
    field: 'fundAmount',
    headerName: 'Fund Sponsor',
    type: 'number',
    minWidth: 120,
  },
  {
    field: 'target',
    headerName: 'Target',
    type: 'number',
    minWidth: 110,
  },
  {
    field: 'totalCredit',
    headerName: 'Credit',
    type: 'number',
    minWidth: 110,
  },
  {
    field: 'totalDebit',
    headerName: 'Debit',
    type: 'number',
    minWidth: 110,
  },
  {
    field: 'progressPergentage',
    headerName: 'Progress',
    type: 'number',
    minWidth: 110,
    valueFormatter: (params) => `${params.value}%`,
  },
  { field: 'progressStatus', headerName: 'Status', minWidth: 120 },
]

export const MapDashboardScreen = () => {
  const { data, isLoading, error, refetch } = useGetMapsDashboard()

  return (
    <Container style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
      <Stack spacing={0.5} mb={3}>
        <Typography variant='h5' fontWeight={600}>
          MAP Summary
        </Typography>
        <Typography variant='body2' color='text.secondary'>
          Overview of fund sponsor targets and progress across all MAP contracts
        </Typography>
      </Stack>
      {error ? (
        <ErrorMessage error={error} onRetry={refetch} />
      ) : isLoading ? (
        <Box
          display='flex'
          alignItems='center'
          justifyContent='center'
          height={480}
          component={Paper}
          variant='outlined'
        >
          <CircularProgress />
        </Box>
      ) : (
        <Paper variant='outlined' sx={{ height: 1000 }}>
          <DataGrid
            rows={data}
            columns={columns}
            slots={{ toolbar: GridToolbar }}
            slotProps={{ toolbar: { showQuickFilter: true } }}
            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
            pageSizeOptions={[10, 25, 50, 100]}
            disableRowSelectionOnClick
            sx={{
              border: 'none',
              '& .MuiDataGrid-columnHeaders': {
                backgroundColor: 'grey.50',
                fontWeight: 600,
              },
              '& .MuiDataGrid-virtualScroller': {
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
                '&::-webkit-scrollbar': {
                  display: 'none',
                },
              },
            }}
          />
        </Paper>
      )}
    </Container>
  )
}
